import apiClient from '../../../utils/lib/apiClient';
import { loadingState, loadingText } from '../../../states/loadingState';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { Dirary } from '../../../types/dirary';
import { userState } from '../../../states/userState';
import { formatDate } from '../../../utils/functions/formatting';
import { useCallback } from 'react';
export const useDeletePosts = () => {
  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);
  const user = useRecoilValue(userState);
  const deletePosts = useCallback(
    async (diaryList: Dirary[]) => {
      setLoadingAnimation(true);
      setLoadingText('削除...');
      const idsOnDiaryList = diaryList.map((diary) => diary.id);
      const reqBody = {
        ids: idsOnDiaryList,
      };
      try {
        const res = await apiClient.post(
          `/rocketForge/posts/deleteDiary/${
            user.mail ?? 'undefined@morimatsu.jp'
          }`,
          reqBody
        );

        const data = res.data;
        return data;
        //   return 0;
      } catch (e) {
        window.alert('エラーが発生しました' + e);
        return null;
      } finally {
        setLoadingAnimation(false);
        setLoadingText('');
      }
    },
    [loadingState, loadingText]
  );

  return deletePosts;
};
